import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, Resolve, Router } from '@angular/router';
import { RunTimeConfigService } from '@shared/services/run-time-config.service';

import { of, throwError } from 'rxjs';
import { catchError, map } from 'rxjs/operators';

@Injectable({
  providedIn: 'root'
})
export class SettingsResolver implements Resolve<any> {
  constructor(private runTimeConfigService: RunTimeConfigService) {}

  resolve(route: ActivatedRouteSnapshot) {
    const app = this.runTimeConfigService
      .getConfig('settingsConfig')
      .globalSettings.apps.find(i => i.app === route.data['app']);

    // app has settings config
    if (app && app.settingsConfig) {
      return this.runTimeConfigService.getAppSpecificSettings(app.settingsConfig).pipe(
        map(appSettings => appSettings),
        catchError(err => throwError(err.json().error))
      );
    } else {
      return of({});
    }
  }
}
